import gql from 'graphql-tag'

export const QUERY_GET_HIGHLIGHTED_OFFERS = gql`
  query HighlightedOffers(
    $page: Int!
    $pageSize: Int!
    $franchise: Boolean!
    $status: [HighlightedOfferStatus!]
    $search: String
    $sort: [String!]
    $sortDirection: [SortDirection!]
  ) {
    highlightedOffers(page: $page, pageSize: $pageSize, franchise: $franchise, status: $status, search: $search, sort: $sort, sortDirection: $sortDirection) {
      highlightedOffers {
        id
        createdAt
        updatedAt
        title
        description
        displayTitle
        type
        status
        iconImage
        offersScheduleId
        draft
        initialDate
        finalDate
        tag {
          image
          active
        }
        products {
          showHome
          sku
        }
        bannerImage
        units {
          active
          _id
          name
        }
      }
      page
      records
    }
  }
`

export const MUTATION_VALIDATE_HIGHLIGHTED_OFFER_UPSERT = gql`
  mutation ValidateHighlightedOfferUpsert($input: ValidateHighlightedOfferUpsertInput!) {
    validateHighlightedOfferUpsert(input: $input) {
      error {
        code
        finalDateFound
        initialDateFound
        message
      }
      valid
    }
  }
`
export const MUTATION_UPSERT_HIGHLIGHT = gql`
  mutation UpsertHighlightedOffer($input: HighlightedOfferInput!) {
    upsertHighlightedOffer(input: $input) {
      message
    }
  }
`

export const MUTATION_DELETE_HIGHLIGHT = gql`
  mutation DeleteHighlightedOffer($deleteHighlightedOfferId: String!) {
    deleteHighlightedOffer(id: $deleteHighlightedOfferId) {
      message
    }
  }
`

export const QUERY_GET_HIGHLIGHT_BY_ID = gql`
  query HighlightedOffer($highlightedOfferId: String!) {
    highlightedOffer(id: $highlightedOfferId) {
      id
      createdAt
      updatedAt
      title
      description
      displayTitle
      type
      status
      bannerImage
      iconImage
      offersScheduleId
      draft
      initialDate
      finalDate
      tag {
        active
        image
      }
      products {
        sku
        name
        image
        ean
        showHome
      }
      productsGroups {
        _id
        name
        showHome
        products {
          _id
          sku
          ean
          eans
          name
        }
      }
      units {
        id_erp
        _id
        ecommerce_id
        name
        cnpj
        address
        contact
        mobile
        pdv_token
        ecommerce_v2_active
        ecommerce {
          active
          products_file {
            url
            filename
            nof_products
            updated_at
          }
        }
        location {
          type
          coordinates
        }
        office_hours {
          monday {
            finish
            start
          }
          tuesday {
            finish
            start
          }
          wednesday {
            finish
            start
          }
          thursday {
            finish
            start
          }
          friday {
            finish
            start
          }
          saturday {
            finish
            start
          }
          sunday {
            finish
            start
          }
          holidays {
            finish
            start
          }
        }
        address_components {
          postal_code
          street
          neighborhood
          number
          complement
          city
          city_name
          federative_unit
          federative_unit_name
        }
        tags {
          name
          color
        }
        active
        unit_group_id
        retailer_flag_id
        ecommerce_partner {
          partner_type
          partner_unit_id
        }
      }
      offersSchedule {
        id
        name
        description
        startDate
        endDate
      }
      metrics {
        bigNumbers {
          clientsViewedTotalUsers
          clientsClickedTotalUsers
          clientsViewedAndPurchasedSomethingTotalUsers
          clientsViewedAndPurchasedSomethingAverageTicket
          clientsViewedAndPurchasedSomethingAverageTicketPercentage
          clientsViewedAndPurchasedSomethingRevenue
          clientsViewedAndPurchasedSomethingRevenuePercentage
        }
        resultsByProfile {
          clientsViewedAndPurchasedSomethingMetrics {
            clients
            clientsPercentage
            revenue
            averageTicket
            tickets
          }
          clientsViewedAndPurchasedProductsMetrics {
            clients
            clientsPercentage
            revenue
            averageTicket
            tickets
          }
          clientsViewedAndPurchasedOnlyTheProductsMetrics {
            clients
            clientsPercentage
            revenue
            averageTicket
            tickets
          }
        }
        productsMetrics {
          code
          name
          clients
          revenue
          tickets
          quantity
          impactedPercentage
        }
        unitsMetrics {
          clients
          name
          averageTicket
          discount
          revenue
        }
        productsTotalMetrics {
          clients
          revenue
          tickets
          quantity
          impactedPercentage
        }
      }
    }
  }
`

export const MUTATION_CLONE_HIGHLIGHTED_OFFER = gql`
  mutation CloneHighlightedOffer($cloneHighlightedOfferId: String!) {
    cloneHighlightedOffer(id: $cloneHighlightedOfferId) {
      id
      message
    }
  }
`

export const MUTATION_UNSCHEDULE_HIGHLIGHT = gql`
  mutation UnscheduleHighlightedOffer($unscheduleHighlightedOfferId: String!) {
    unscheduleHighlightedOffer(id: $unscheduleHighlightedOfferId) {
      message
    }
  }
`

export const MUTATION_FINISH_ACTIVE_HIGHLIGHT = gql`
  mutation FinishActiveHighlight($finishHighlightedOfferId: String!) {
    finishHighlightedOffer(id: $finishHighlightedOfferId) {
      message
    }
  }
`
